import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import AlertView from '../../Alert/View/AlertView';
import CreateAlert from '../../Alert/Create/CreateAlert';
import AlertsStats from '../../Alert/AlertsStats/AlertsStats';
import AlertControlCenter from '../../Alert/ControlCenter/AlertControlCenter';
import GoogleAlertStatistics from '../../Alert/GoogleStatistics/GAAlertStatistics';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.ALERTS, routes.ALERTSCLOSED],
    component: AlertView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.CREATEALERT, routes.CREATEALERTBYCASE, routes.EDITALERT],
    component: CreateAlert,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.ALERTSSTATS],
    component: AlertsStats,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.ALERT_CONTROL_CENTER],
    component: AlertControlCenter,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.ALERTGOOGLESTATS],
    component: GoogleAlertStatistics,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  }
]);

export const alertsModule = (): IRouteModule => ({
  name: RoutesModules.ALERTS,
  routes: moduleRoutes(),
  navbar: routes.ALERTS,
  sidebar: [
    {
      navTitle: 'Active alerts',
      route: routes.ALERTS
    },
    {
      navTitle: 'Closed alerts',
      route: routes.ALERTSCLOSED,
    },
    {
      navTitle: 'Stats',
      route: routes.ALERTSSTATS
    },
    {
      navTitle: 'Control Center',
      route: routes.ALERT_CONTROL_CENTER,
      hideOnMobile: true
    },
    {
      isFormLink: true,
      navTitle: 'Add new alert',
      route: routes.ADDALERT
    }
  ]
});

// export default alertsModule;